import { Button, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHRForLocation } from '../../offices/offices-selectors';
import { saveHRDetails } from '../../offices/offices-actions';
import { getWriteTabsPermissions } from '../../../store/user/user-reducer';
import { formItemMap } from '@med-fe/ui';
import { hrConfig } from '../configs/hr-config';

function HRDetails({ locId }) {
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useDispatch();
  const data = useSelector((state) => getHRForLocation(state, locId));
  const isEditAllowed = useSelector(getWriteTabsPermissions).hr;

  useEffect(() => {
    form.setFieldsValue({
      ...data,
    });
  }, [locId]);

  const onSubmit = (formData: any) => {
    const payload = {
      id: locId,
      doctorLocationGrouping: formData.doctorLocationGrouping?.trim() || null,
      stipend: formData.stipend ?? null,
      pathways: formData.pathways ?? null,
      tuitionReimbursement: formData.tuitionReimbursement ?? null,
    };
    dispatch(saveHRDetails(payload));
  };

  return (
    <Form
      form={form}
      layout='vertical'
      className='hr-details-form'
      onFinish={(formData) => {
        onSubmit(formData);
        setIsDisabled(true);
      }}
      onValuesChange={() => setIsDisabled(false)}
    >
      {Object.entries(hrConfig).map(([key, value]: any) => {
        const params = {
          key,
          label: value.label,
          name: key,
          rules: value.rules,
          data: value.data,
          ...(value.type === 'checkbox' && { valuePropName: 'checked' }),
        };

        return <Form.Item {...params}>{formItemMap(value, value.readOnly || !isEditAllowed)}</Form.Item>;
      })}

      <Form.Item>
        <Button type='primary' htmlType='submit' className={'btn-form-action'} disabled={!isEditAllowed || isDisabled}>
          SAVE
        </Button>
      </Form.Item>
    </Form>
  );
}

export default HRDetails;
